module.exports = __webpack_public_path__ + "static/img/biankuang03.5647bc9.png";


//////////////////
// WEBPACK FOOTER
// ./static/biankuang03.png
// module id = jZuR
// module chunks = 1